var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptureLogoDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "40 430 940 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CC63E",
    d: "M113.5,574.7c-8.8,0-17.3-1.5-25.2-4.9c-7.9-3-14.9-7.6-20.9-13.3c-6.1-5.8-10.9-12.7-14.6-20.9s-5.5-17-5.5-27v-0.3c0-9.4,1.8-18.2,5.2-26.4c3.3-8.2,8.2-15.2,14.3-21.2c6.1-6.1,13.3-10.6,21.5-14c8.2-3.3,17-4.9,26.7-4.9c7,0,13.3,0.9,19.4,2.4c5.8,1.5,11.2,3.9,16.1,7c4.9,3,9.1,6.4,12.7,10.6c3.6,3.9,7,8.5,9.4,13.3l-35.2,20.6c-2.4-4.6-5.5-8.2-9.1-11.2c-3.6-2.7-8.2-4.2-14-4.2c-3.6,0-7,0.6-9.7,2.1c-3,1.5-5.5,3.3-7.6,6.1c-2.1,2.4-3.6,5.5-4.9,8.8c-1.2,3.3-1.8,7-1.8,10.6v0.3c0,4.2,0.6,7.9,1.8,11.5c1.2,3.3,2.7,6.4,4.9,8.8c2.1,2.4,4.6,4.6,7.6,5.8c3,1.2,6.1,2.1,9.7,2.1c6.1,0,10.9-1.5,14.6-4.6c3.6-3,6.7-7,9.4-11.5l35.2,19.7c-2.7,4.9-5.8,9.1-9.4,13.3c-3.6,4.2-7.9,7.9-12.7,10.9c-4.9,3-10.6,5.5-16.7,7.3C128.3,573.7,121.4,574.7,113.5,574.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M217.5,440.5h42.2l53.7,128.3h-46.1l-6.7-17H216l-15.8,38.2h-45.5L217.5,440.5z M250,521.6l-11.5-30.9l-11.5,30.9H250z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M316.5,440.5h57.3c8.5,0,16.1,0.9,23.4,2.7c7,1.8,13,4.9,17.9,8.5c4.9,3.6,8.8,8.5,11.5,14.3c2.7,5.8,4.2,12.4,4.2,19.7v0.3c0,7.6-1.5,14.6-4.2,20.3c-2.7,5.8-6.7,10.9-11.8,14.9c-5.2,3.9-11.2,7-18.2,9.1c-7,2.1-14.9,3-23.7,3h-14V568h-42.5V440.5L316.5,440.5z M370.5,503c5.5,0,9.7-1.2,13-3.6s5.2-5.8,5.2-10.6v-0.3c0-4.6-1.5-8.2-4.9-10.6c-3-2.4-7.6-3.6-13.3-3.6h-11.5v28.5h11.5V503z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M466.6,476.7H429v-36.1h117.7v36.1h-37.6V568h-42.5L466.6,476.7L466.6,476.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M601.1,570.4c-9.4,0-18.2-1.2-25.8-3.3c-7.6-2.1-14.3-5.8-19.7-10.6c-5.5-4.9-9.7-10.9-12.7-18.5c-3-7.6-4.6-16.7-4.6-27v-70.4h43.4v69.8c0,7.9,1.8,13.7,5.5,17.3c3.6,3.6,8.5,5.5,14.3,5.5s10.6-1.5,14.3-5.2c3.6-3.3,5.5-8.8,5.5-16.7v-70.7h43.4V510c0,10.9-1.5,20.3-4.6,27.9c-3,7.6-7.3,14-12.7,18.8c-5.5,4.9-12.1,8.5-20,10.6C619.3,569.5,610.5,570.4,601.1,570.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M673.9,440.5h62.2c11.5,0,20.6,1.2,28.2,3.9c7.3,2.7,13.3,6.1,17.9,10.6c3.9,3.9,6.7,8.2,8.8,13c1.8,4.9,3,10.6,3,17v0.3c0,9.4-2.1,17.3-6.7,23.7s-10.6,11.5-18.5,15.2l29.7,43.4H750l-24-36.4h-0.9h-8.8v36.4h-42.5V440.5z M734.9,501.2c5.2,0,9.1-1.2,12.1-3.3s4.2-5.2,4.2-9.1v-0.3c0-4.2-1.5-7.3-4.2-9.1c-3-2.1-7-3-11.8-3h-18.5v24.9H734.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M801.3,440.5h66.1v34.9h-24.3v13h62.2v30.6h-62.2v14h67.7V568H801.3L801.3,440.5L801.3,440.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 878.7,
    y: 440.5,
    fill: "#565B5A",
    width: 35.2,
    height: 35.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 913.6,
    y: 475.4,
    fill: "#FFFFFF",
    width: 35.2,
    height: 35.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 948.8,
    y: 452.4,
    fill: "#8CC63E",
    width: 24.9,
    height: 23.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureLogoDark);
export default __webpack_public_path__ + "static/media/captureLogoDark.ef63661c721073fb0577c6b98ff16063.svg";
export { ForwardRef as ReactComponent };